module.exports = __webpack_public_path__ + "img/l2wave.3c1922df.svg";